export default {"src":"/_next/static/media/hero-backgrund-gradient-desktop.33e3d1ac.svg","height":1403,"width":1440,"blurWidth":0,"blurHeight":0};